import {ActivityFilter, Period, PolicyFilter, UserFilters} from 'modules/decisionsNext/api/types';

export type PolicyFilterKey =
  | keyof PolicyFilter
  | `period.${keyof Period}`
  | `userFilters.${keyof UserFilters}`
  | `activityFilter.${keyof ActivityFilter}`;

export const departmentFilterKeys = ['departmentIds'] satisfies PolicyFilterKey[];
export type DepartmentFilterKeys = (typeof departmentFilterKeys)[number];

export const industryFilterKeys = [
  'industryGroupIds',
  'industryIds',
  'industrySubGroupIds',
] satisfies PolicyFilterKey[];
export type IndustryFilterKeys = (typeof industryFilterKeys)[number];

export const confidenceScoreFilterKeys = ['naicsSourceConfidenceScore'] satisfies PolicyFilterKey[];
export type ConfidenceScoreFilterKeys = (typeof confidenceScoreFilterKeys)[number];

export const carrierTypeFilterKeys = ['brokerMarketStatuses'] satisfies PolicyFilterKey[];

export const carrierFilterKeys = [
  'ultimateCarrierIds',
  'parentCarrierIds',
  'issuingPaperIds',
] satisfies PolicyFilterKey[];
export type CarrierFilterKeys = (typeof carrierFilterKeys)[number];

export const intermediaryFilterKeys = [
  'ultimateIntermediaryIds',
  'parentIntermediaryIds',
  'childIntermediaryIds',
] satisfies PolicyFilterKey[];
export type IntermediaryFilterKeys = (typeof intermediaryFilterKeys)[number];

export const marketFilterKeys = [
  ...carrierFilterKeys,
  ...intermediaryFilterKeys,
  ...carrierTypeFilterKeys,
] satisfies PolicyFilterKey[];
export type MarketFilterKeys = (typeof marketFilterKeys)[number];

export const accountExecutiveFilterKeys = ['userFilters.accountExecutiveIdsAndSourceCodes'] satisfies PolicyFilterKey[];
export type AccountExecutiveFilterKeys = (typeof accountExecutiveFilterKeys)[number];

export const accountManagerFilterKeys = ['userFilters.accountManagerIdsAndSourceCodes'] satisfies PolicyFilterKey[];
export type AccountManagerFilterKeys = (typeof accountManagerFilterKeys)[number];

export const producerFilterKeys = ['userFilters.producerIdsAndSourceCodes'] satisfies PolicyFilterKey[];
export type ProducerFilterKeys = (typeof producerFilterKeys)[number];

export const teamsFilterKeys = ['userFilters'] satisfies PolicyFilterKey[];
export type TeamsFilterKeys = (typeof teamsFilterKeys)[number];

export const productFilterKeys = [
  'productIds',
  'productGroupIds',
  'productInsuranceSegmentIds',
  'productSuperGroupIds',
] satisfies PolicyFilterKey[];
export type ProductFilterKeys = (typeof productFilterKeys)[number];

export const locationFilterKeys = ['location'] satisfies PolicyFilterKey[];
export type LocationFilterKeys = (typeof locationFilterKeys)[number];

export const producerCreditFilterKeys = ['datasourceType'] satisfies PolicyFilterKey[];
export type ProducerCreditFilterKeys = (typeof producerCreditFilterKeys)[number];

export const clientAgencyCodesFilterKeys = ['clientAgencyCodes'] satisfies PolicyFilterKey[];
export type ClientAgencyCodesFilterKeys = (typeof clientAgencyCodesFilterKeys)[number];

export const policyAgencyCodesFilterKeys = ['policyAgencyCodes'] satisfies PolicyFilterKey[];
export type PolicyAgencyCodesFilterKeys = (typeof policyAgencyCodesFilterKeys)[number];

export const stateFilterKeys = ['states'] satisfies PolicyFilterKey[];
export type StatesFilterKeys = (typeof stateFilterKeys)[number];

export const DEFAULT_FILTER_NAME = 'Default-Agency';

export const periodFilterKeys = [
  'datasourceType',
  'policyStatusType',
  'policyStatusesAnd',
  'additionalPeriods',
  'period',
] satisfies PolicyFilterKey[];
export type PeriodFilterKeys = (typeof periodFilterKeys)[number];
